var initObj = {
  visible: true,
};

export function lsNavigatiorConditionInit() {
  localStorage.setItem('NavigatiorCondition', JSON.stringify(initObj));
}
